export default __webpack_public_path__ + "static/media/3425.9edce0c2.png";